<template>
    {{ $t('NotFound') }}!
</template>